var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 0.163086H3.00008V1.32975H10.0001M3.00008 2.49642H10.0001V3.66309H3.00008M0.666748 4.24642H1.83341V7.16309H11.1667V4.24642H12.3334V7.16309C12.3334 7.47251 12.2105 7.76925 11.9917 7.98804C11.7729 8.20684 11.4762 8.32975 11.1667 8.32975H1.83341C1.524 8.32975 1.22725 8.20684 1.00846 7.98804C0.789664 7.76925 0.666748 7.47251 0.666748 7.16309M10.0001 4.82975H3.00008V5.99642H10.0001V4.82975Z",
    fill: "#163C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.d8af9f79d72402dd59514c3bd42e692f.svg";
export { ForwardRef as ReactComponent };